import parsePhoneNumber from 'libphonenumber-js';

export const formartPhoneNo = (phone: string) => {
  const phoneNumber = parsePhoneNumber(phone, 'KE');
  if (phoneNumber.isValid())
    return phoneNumber.formatInternational().replaceAll(' ', '').replace('+', '');

  return phone;
};
